import { createAction, props } from "@ngrx/store";
import {
  GridTaskResponseI, MapResultResponseI,
  ProcessResultFilterI,
  ProcessResultI,
  ProcessResultResponseI,
  ProcessResultTab, SearchParameters,
  ViewComponentType
} from "../../interfaces/process-result.interface";
import {ActivityI, DetailTabs, TaskI, TaskPermissionsObjectI} from "../../interfaces/task.interface";
import {TaskStateI} from "../../interfaces/process.interface";

export const setLoadingResultTaskAction = createAction(
  "[Process Result List] Set Loading Result Task Action",
  props<{
    status: boolean
  }>()
);

export const setLoadingResult = createAction(
  "[Process Result List] Set Loading Result",
  props<{
    status: boolean
  }>()
);

export const setLoadingBookmarked = createAction(
  "[Process Result List] Set Loading Bookmarked",
  props<{
    status: boolean
  }>()
);

export const setLoadingCreateResult = createAction(
  "[Process Result List] Set Loading Create Result",
  props<{
    status: boolean
  }>()
);


export const setLoadingDetailProcessResult = createAction(
  "[Process Result List] Set Loading Detail Process Result",
  props<{
    status: boolean
  }>()
);

export const setLoadingProcessResultPermissions = createAction(
  "[Process Result List] Set Loading Process Result Permissions",
  props<{
    status: boolean
  }>()
);

export const setLoadingProcessResultMap = createAction(
  "[Process Result List] Set Loading Process Result Map",
  props<{
    status: boolean
  }>()
);

export const setloadingBulkRemoveProcessResult = createAction(
  "[Process Result List] Set Loading Bulk Remove Process Result",
  props<{
    status: boolean
  }>()
);

export const setLoadingBulkStatusProcessResult = createAction(
  "[Process Result List] Set Loading Bulk Status Process Result",
  props<{
    status: boolean
  }>()
);

export const setLoadingBulkStatusTaskResult = createAction(
  "[Process Result List] Set Loading Bulk Status Task Result",
  props<{
    status: string
  }>()
);

export const setLoadingBulkActionButton = createAction(
  "[Process Result List] Set Loading Bulk Action Button",
  props<{
    button: string
  }>()
);


export const createProcessResult = createAction(
  "[Process Result List] Create Process Result",
  props<{
    processId: string
  }>()
);

export const createProcessResultSuccess = createAction(
  "[Process Result List] Create Process Result Success",
  props<{
    result: ProcessResultI
  }>()
);

export const loadSocketProcessResult = createAction(
  "[Process Result List] Load Socket Process Result",
  props<{
    processId: string,
    resultId: string
  }>()
);

export const loadSocketProcessResultSuccess = createAction(
  "[Process Result List] Load Socket Process Result Success",
  props<{
    result: ProcessResultI
  }>()
);


export const loadSelectedProcessResult = createAction(
	"[Process Result List] Load Selected Process Result",
	props<{
    processId: string,
    resultId: string
  }>()
);

export const loadSelectedProcessResultSuccess = createAction(
  "[Process Result List] Load Selected Process Result Success",
  props<{
    result: ProcessResultI
  }>()
);

export const loadProcessResultList = createAction(
  "[Process Result List] Load Process Result List",
  props<{
    processId: string,
    page: number  | string,
    limit: number | string,
    bookmarked:  string | null | boolean,
    process_status: string[] |string | null,
    tasks: string[] | string | null,
    filter: any,
    globalSearch: string
  }>()
);

export const loadProcessResultListSuccess = createAction(
  "[Process Result List] Load Process Result List Success",
  props<{
    response: ProcessResultResponseI
  }>()
);

export const loadProcessResults = createAction(
  "[Process Result List] Load Process Results",
  props<{
    processId: string
  }>()
);

export const loadProcessResultsSuccess = createAction(
  "[Process Result List] Load Process Results Success",
  props<{
    response: ProcessResultResponseI
  }>()
);

export const changeStatusProcessResult = createAction(
  "[Process Result List] Change Status Process Result",
  props<{
    previousStatus: TaskStateI,
    processId: string,
    resultId: string,
    data: ProcessResultI
  }>()
);

export const changeStatusProcessResultSuccess = createAction(
  "[Process Result List] Change Status Process Result Success",
  props<{
    previousStatus: TaskStateI,
    index: number | null,
    result: ProcessResultI
  }>()
);

export const bookmarkProcessResult = createAction(
  "[Process Result List] Bookmark Process Result",
  props<{
    processId: string,
    resultId: string,
    data: ProcessResultI
  }>()
);

export const bookmarkProcessResultSuccess = createAction(
  "[Process Result List] Bookmark Process Result Success",
  props<{
    result: ProcessResultI
  }>()
);

export const deleteProcessResult = createAction(
  "[Process Result List] Delete Process Result",
  props<{
    processId: string,
    resultId: string
  }>()
);

export const executeResultTaskAction = createAction(
  "[Process Result List] Execute Result Task Action",
  props<{
    processId: string,
    resultId: string,
    taskId: string,
    status: TaskStateI
  }>()
);

export const executeResultTaskActionSuccess = createAction(
  "[Process Result List] Execute Result Task Action Success",
  props<{
    result: ProcessResultI
  }>()
);

export const patchResultTask = createAction(
  "[Process Result List] Patch Result Task",
  props<{
    processId: string,
    resultId: string,
    task: TaskI,
    activity: ActivityI,
    data: any,
    nextStatus: TaskStateI | null
  }>()
);

export const patchResultTaskSuccess = createAction(
  "[Process Result List] Patch Result Task Success",
  props<{
    result: ProcessResultI
  }>()
);

export const loadDetailProcessResult = createAction(
  "[ Process Result List ] Load Detail Process Result",
  props<{
    processId: string,
    resultId: string
  }>()
);

export const setDetailProcessResult = createAction(
  "[ Process Result List ] Set Detail Process Result",
  props<{
    result: ProcessResultI | null
  }>()
);

export const setViewComponentProcessResult = createAction(
  "[ Process Result List ] Set View Component Process Result",
  props<{
    value: ViewComponentType
  }>()
);

export const updateProcessResultPermissions = createAction(
  "[ Process Result List ] Update Process Result Permissions",
  props<{
    processId: string,
    resultId: string,
    data: TaskPermissionsObjectI
  }>()
);

export const updateProcessResultPermissionsSuccess = createAction(
  "[ Process Result List ] Update Process Result Permissions Success",
  props<{
    result: ProcessResultI
  }>()
);

export const removeProcessResultPermissions = createAction(
  "[ Process Result List ] Remove Process Result Permissions",
  props<{
    processId: string,
    resultId: string,
    data: TaskPermissionsObjectI
  }>()
);

export const setShowFilterBar = createAction(
  "[ Process Result List ] Set Show Filter Bar",
  props<{
    status: boolean
  }>()
);

export const setShowRightBar = createAction(
  "[ Process Result List ] Set Show Right Bar",
  props<{
    status: boolean
  }>()
);

export const setResultDetailsTab = createAction(
  "[ Process Result List ] Set Result Details Tab",
  props<{
    tab: DetailTabs
  }>()
);

export const setProcessResultTab = createAction(
  "[ Process Result List ] Set Process Result Tab",
  props<{
    tab: ProcessResultTab
  }>()
);

export const resetProcessResultKanban = createAction(
  "[Process Result List] Reset process result kanban",
  props<{
    status: string
  }>()
)

export const loadProcessResultKanban = createAction(
  "[Process Result List] Load process result kanban",
  props<{
    processId: string,
    page: number  | string,
    limit: number | string,
    process_status: string[] |string | null,
    reset: boolean
  }>()
)

export const loadProcessResultKanbanSuccess = createAction(
  "[Process Result List] Load Process Result Kanban Success",
  props<{
    page: number,
    limit: number,
    status: string,
    reset: boolean,
    response: ProcessResultResponseI
  }>()
);

export const loadProcessResultMap = createAction(
  "[Process Result List] Load process result map",
  props<{
    processId: string,
    page: number  | string,
    limit: number | string,
    bookmarked:  string | null | boolean,
    process_status: string[] |string | null,
    tasks: string[] | string | null,
    filter: any,
    globalSearch: string,
    reset: boolean
  }>()
)

export const resetProcessResultMap = createAction(
  "[Process Result List] Reset process result map success"
)

export const loadProcessResultMapSuccess = createAction(
  "[Process Result List] Load process result map success",
  props<{
    response: MapResultResponseI
  }>()
)

export const setProcessResultFilter = createAction(
  "[Process Result List] Set Process Result Filter",
  props<{
    filter: ProcessResultFilterI
  }>()
);

export const setProcessResultGlobalSearch = createAction(
  "[Process Result List] Set Process Result Global Search",
  props<{
    query: string
  }>()
);

export const setLoadingProcessResultGridData = createAction(
  "[Process Result List] Set Loading Process Result Grid Data",
  props<{
    status: boolean
  }>()
);

export const setLoadingActionButton = createAction(
  "[Process Result List] Set Loading Action Button",
  props<{
    button: string,
    status: boolean
  }>()
);

export const loadProcessResultGridData = createAction(
  "[Process Result List] Load Process Result Grid Data",
  props<{
    processId: string;
  }>()
);

export const loadProcessResultGridDataSuccess = createAction(
  "[Process Result List] Load Process Result Grid Data Success",
  props<{
    response: GridTaskResponseI
  }>()
);

export const setGridDefaultState = createAction(
  "[Process Result List] Set grid default state",
  props<{
    state: TaskStateI
  }>()
);

export const dispatchActionButton = createAction(
  "[Process Result List] Dispatch action button",
  props<{
    buttonId: string,
    processId: string,
    processResultId: string
  }>()
);

export const dispatchActionButtonSuccess = createAction(
  "[Process Result List] Dispatch action button success",
  props<{
    buttonId: string,
    processId: string,
    processResultId: string
  }>()
);

// Search parameters actions
export const setSearchParameters = createAction(
  "[Process Result List] Set Search Parameters",
  props<{
    value: any
  }>()
);
export const setParameterInitial = createAction(
  "[Process Result List] Set Parameter Initial",
  props<{
    value: boolean
  }>()
);
export const setParameterOrderBy = createAction(
  "[Process Result List] Set Parameter Order By",
  props<{
    value: string
  }>()
);
export const setParameterOrder = createAction(
  "[Process Result List] Set Parameter Order",
  props<{
    value: "asc" | "desc" | null
  }>()
);
export const setParameterPage = createAction(
  "[Process Result List] Set Parameter Page",
  props<{
    value: string | number
  }>()
);
export const setParameterEntries = createAction(
  "[Process Result List] Set Parameter Entries",
  props<{
    value: string | number
  }>()
);
export const setParameterDynamicFilters = createAction(
  "[Process Result List] Set Parameter Dynamic Filters",
  props<{
    value: any
  }>()
);
export const setParameterProcessStatusFilters = createAction(
  "[Process Result List] Set Parameter Process Status Filters",
  props<{
    value: any
  }>()
);
export const setParameterProcessTasksFilters = createAction(
  "[Process Result List] Set Parameter Process Tasks Filters",
  props<{
    value: any
  }>()
);
export const setParameterBookmarkedFilters = createAction(
  "[Process Result List] Set Parameter Bookmarked Filters",
  props<{
    value: 'active' | 'inactive'
  }>()
);
export const setParameterSearchFilters = createAction(
  "[Process Result List] Set Parameter Search Filters",
  props<{
    value: string | null
  }>()
);
//bulk actions
export const updateBulkProcessResult = createAction(
  "[Process Result List] Update bulk Process Result",
  props<{
    processId: string,
    objectIds: string[],
  }>()
);
export const updateBulkProcessResultSuccess = createAction(
  "[Process Result List] Update bulk Process Result Success",
  props<{
    processResultList: ProcessResultI[]
  }>()
);
export const toggleSelectionProcessResult = createAction(
  "[Process Result List] Toggle Selection Process Result",
  props<{
    value: ProcessResultI
  }>()
);

export const setSelectedProcessResults = createAction(
  "[Process Result List] Set Selected Process Result",
  props<{
    value: ProcessResultI[]
  }>()
);

export const bulkRemoveProcessResult = createAction(
  "[Process Result List] Bulk Remove Process Result",
  props<{
    processId: string,
    values: string[]
  }>()
);

export const bulkStatusProcessResult = createAction(
  "[Process Result List] Bulk Status Process Result",
  props<{
    processId: string,
    objectIds: string[],
    status: TaskStateI
  }>()
);

export const bulkStatusTaskResult = createAction(
  "[Process Result List] Bulk Status Task Result",
  props<{
    processId: string,
    taskId: string,
    objectIds: string[],
    status: TaskStateI
  }>()
);

export const setBulkRemoveJobId = createAction(
  "[Process Result List] Set Bulk Update Job Result",
  props<{
    jobId: string,
  }>()
);

export const setBulkStatusJobId = createAction(
  "[Process Result List] Set Bulk Status Job Result",
  props<{
    jobId: string,
  }>()
);

export const setBulkTaskStatusJobId = createAction(
  "[Process Result List] Set Bulk Task Status Job Result",
  props<{
    jobId: string,
  }>()
);

export const dispatchBulkActionButton = createAction(
  "[Process Result List] Dispatch bulk action button",
  props<{
    buttonId: string,
    processId: string,
    processResultIds: string[],
    all: boolean
  }>()
);





